export default "__VITE_ASSET__e5f375b1__"